import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

/**
 * @description base class including text color modifications logic
 */
export abstract class TextColorBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.TEXT_COLOR;
  }
}
